export const themes = {
  default: {
    thList: 'flex gap-20 isolate relative max-w-full',
    thItem: 'flex-1 flex flex-col items-stretch relative',
    thSymbol:
      'size-46 absolute bg-white flex font-bold items-center justify-center leading-0 -mx-10 p-10 right-0 rounded-full text-black text-24 top-1/2 transform ltr:translate-x-1/2 rtl:-translate-x-1/2 -translate-y-1/2 z-1',
  },
};
